module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 114\">\n  <g id=\"scroll-icon\">\n    <circle stroke=\"#000\" fill=\"#fff\" stroke-miterlimit=\"10\" stroke-width=\"4px\" cx=\"57\" cy=\"57\" r=\"55\"/>\n    <polyline stroke=\"#000\" fill=\"none\" stroke-miterlimit=\"10\" stroke-width=\"4px\" points=\"80.96 65.04 57 89 33.04 65.04\"/>\n    <line stroke=\"#000\" fill=\"none\" stroke-miterlimit=\"10\" stroke-width=\"4px\" x1=\"57\" y1=\"88.8\" x2=\"57\" y2=\"20\"/>\n  </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/images/icons/scroll-icon.svg
// module id = 1261
// module chunks = 37